import Link from 'next/link';
import React, { memo } from 'react';
import router from 'next/router';

import { capitalizeFLetter } from '@/utils/helpers';
function Details({ adsDetail }: { adsDetail: any }) {
  return (
    <>
      <div className="search open">
        <button onClick={() => router.back()} type="button" title="Back to Search">
          <span className="arrow-button">
            <i className="fa fa-arrow-left"></i>
          </span>
          <div className="bks">Back to search</div>
        </button>
      </div>
      <div className="tagcard">
        <strong>{adsDetail.age} YEARS</strong>
        <strong className="normal-f">{capitalizeFLetter(adsDetail.category)}</strong>
        <strong>
          <i className="fa fa-map-marker"></i>
          {capitalizeFLetter(adsDetail.city)}
        </strong>
      </div>
      <div className="add-id">
        <span>Ad ID :</span> <strong>{adsDetail.adsNo}</strong>
      </div>
      <div className="details-row">
        <div className="details-left-items">
          <h1 className="item-title">{`${adsDetail.extra_title} ${adsDetail.title}`}</h1>
          <p dangerouslySetInnerHTML={{ __html: adsDetail?.description ?? '' }} />
        </div>
        <div className="details-right-items">
          <div className="coll-to-action-row">
            <div className="item-card-contact">
              {adsDetail.is_call && (
                <Link href={`tel:+91${adsDetail?.contact_no}`} className="btntelephone">
                  <i className="fa fa-phone"></i> <span>CALL ME</span>
                </Link>
              )}

              {adsDetail.is_whatsapp && (
                <Link
                  href={`https://api.whatsapp.com/send/?phone=${adsDetail?.contact_no}&amp;text=${adsDetail?.contact_no},and I'd like to meet you.`}
                  className="btncontact"
                >
                  <img
                    loading="lazy"
                    src="/assets/img/whatsapp.webp"
                    width={25}
                    className="whatsapp-img"
                    alt="whatsapp"
                  />
                  WHATSAPP
                </Link>
              )}
              <a className="reportad" target="_blank" href="#">
                REPORT AD
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="gallery-section">
        <div className="row">
          {adsDetail.ads_images.map((images: any, index: number) => (
            <div key={index} className="col-md-4">
              <div className="gallery-box">
                <div className="gallery-img">
                  <img
                    loading="lazy"
                    src={process.env.REACT_APP_API_UPLOADS + images.image_url}
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null; // prevents looping
                      currentTarget.src = '/assets/img/no-found.webp';
                    }}
                    alt={adsDetail.title}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* <div className="service-list">
        <div className="row">
          {adsDetail?.services?.split(':').map((item: string, index: number) => (
            <div key={index} className="col-md-3">
              {item}
            </div>
          ))}
        </div>
      </div> */}
      <div className="details" style={{ marginTop: '10px' }}>
        <div className="row">
          <p>
            {capitalizeFLetter(adsDetail.city)}-based call girl {adsDetail?.extra_title.split(' ')[0]} is well-known
            within the business for her secrecy and professionalism. She has a number of years of experience and a solid
            reputation for offering her clients top-notch services. {adsDetail?.extra_title.split(' ')[0]} has
            experience satisfying a good range of tastes and ensuring that her clients are happy. Her clients value her
            attention to detail and her capacity to create a secure and welcoming atmosphere for them.
          </p>
          <h3>
            Services Provided By {adsDetail?.extra_title.split(' ')[0]} As A Call Girl In{' '}
            {capitalizeFLetter(adsDetail.city)}
          </h3>
          <p>
            In {capitalizeFLetter(adsDetail.city)},{adsDetail?.extra_title.split(' ')[0]} is a call girl who provides
            services. Her specialty is offering company for little get-togethers, private parties, and social events.
            {adsDetail?.extra_title.split(' ')[0]} also provides discreet, expert services that are customized to every
            client's unique requirements and preferences. Her services are renowned for being kind, judgment-free, and
            centered on ensuring her companions are comfortable and satisfied.
          </p>
          <p>
            {capitalizeFLetter(adsDetail.city)} call girl {adsDetail?.extra_title.split(' ')[0]} focuses on offering a
            spread of services to suit different tastes. She is well-known for her skill in providing blowjobs,
            cum-on-face, hand jobs, and ensuring her clients get sexy. She stands call in the marketplace for her
            meticulous attention to detail and dedication to satisfying the requirements of individuals trying to find
            personal experiences.
          </p>
          <h3>
            Specialty Of {adsDetail?.extra_title.split(' ')[0]} As A Call Girl In {capitalizeFLetter(adsDetail.city)}
          </h3>
          <p>
            Apart from her sex services, {adsDetail?.extra_title.split(' ')[0]} is superb at offering her client's
            friendship. She makes sure that folks feel appreciated and understood during their time together, whether
            it's via deep talks or simply being a supporting presence. Her ability to supply a comfortable and friendly
            environment adds to the pleasure of individuals who come to her for company. In addition,{' '}
            {adsDetail?.extra_title.split(' ')[0]} is in great demand due to her confidentiality and professionalism
            when getting to social gatherings with customers. She moves with elegance and beauty, fitting in well during
            a social situation. Her ability to adapt and her grasp of social graces make her a well-liked option for
            anyone who needs a sophisticated, charming companion to travel with them to gatherings.
          </p>
        </div>
      </div>
    </>
  );
}

export default memo(Details);
